import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ searchQuery, onClearSearch }) => {
  return (
    <div className="empty-state flex flex-col items-center justify-center py-12 md:py-16 lg:py-20 px-4">
      <div className="empty-state-icon bg-muted/50 rounded-full p-6 md:p-8 mb-4 md:mb-6">
        <Icon name="Search" size={48} color="var(--color-muted-foreground)" />
      </div>
      
      <h3 className="text-xl md:text-2xl font-heading font-semibold text-foreground mb-2 text-center">
        No dishes found
      </h3>
      
      <p className="text-sm md:text-base text-muted-foreground text-center mb-6 max-w-md">
        {searchQuery 
          ? `We couldn't find any dishes matching "${searchQuery}". Try different keywords or browse our categories.`
          : "No dishes available in this category at the moment."}
      </p>

      {searchQuery && (
        <Button
          variant="outline"
          onClick={onClearSearch}
          iconName="X"
          iconPosition="left"
          iconSize={16}
          className="touch-target transition-smooth active:scale-96"
        >
          Clear Search
        </Button>
      )}
    </div>
  );
};

export default EmptyState;